import { type ActivityContentObjectDetail, createActivityContentObjectDetail } from 'models';
import { useMutation } from 'query';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- Break circular dependency
import { useContentObjectCache } from 'features/feed/queries/cache';
import { updateActivity } from '../../services';

type UpdateActivity = {
  activity: UpdateActivityBody;
  routeParams: { id: string };
};

type UpdateActivityBody = {
  description?: string;
  endTime?: Date;
  htmlDescription?: string;
  isWithings?: boolean;
  multipleSubmissions?: boolean;
  name?: string;
  periodicityType?: string;
  programsTopic?: { id: string };
  programsTopicId: string;
  reminders?: Array<{ minutes: number }>;
  startTime?: Date;
  tasks?: Array<{ input?: string; kind?: string; name?: string }>;
  times?: Array<{ id?: string; time: string }>;
};

/**
 * @deprecated AI-generated code, not reviewed. Needs revision before further use — do not use as a reference or pattern to follow.
 */
export const useUpdateActivityMutation = () => {
  const cache = useContentObjectCache();

  return useMutation<ActivityContentObjectDetail, UpdateActivity>({
    async mutationFn({ activity, routeParams }) {
      const response = await updateActivity({
        body: {
          description: activity.description,
          end_time: activity.endTime ? activity.endTime.toISOString() : undefined,
          html_description: activity.htmlDescription,
          is_withings: activity.isWithings,
          multiple_submissions: activity.multipleSubmissions,
          name: activity.name,
          periodicity_type: activity.periodicityType,
          programs_topic: { id: activity.programsTopicId },
          programs_topic_id: activity.programsTopicId,
          reminders: activity.reminders,
          start_time: activity.startTime ? activity.startTime.toISOString() : undefined,
          tasks: activity.tasks,
          times: activity.times,
        },
        routeParams,
      });

      return createActivityContentObjectDetail(response.data);
    },
    onSuccess(data) {
      cache.replace(data);
    },
  });
};
